import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const JOURNAL_RUNS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('JOURNAL_RUNS');
export const JOURNAL_RUNS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	JOURNAL_RUNS_CRUD_ACTION_CONSTANTS
);
